import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { AttachFilesFromExistingDocsExecutorModal } from './AttachFilesFromExistingDocsExecutorModal';
import { IAttachFilesFromExistingDocsExecutorProps } from './IAttachFilesFromExistingDocsExecutorProps';

export class AttachFilesFromExistingDocsExecutor extends DocBaseActionExecutor {
    private _modalProps?: IAttachFilesFromExistingDocsExecutorProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            action: action,
            completeHandler: completeHandler,

            payloadData: action.options.actionData,
            docData: action.options.docData,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <AttachFilesFromExistingDocsExecutorModal {...this._modalProps} /> : <div />;
    };
}
